import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import physics_tool from "../../engines/libs/physics_tool";
import utilsModel from "../../engines/libs/utilsModel";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { archeryCoilderTag } from "../archeryGameBundle/archeryConst";
import archeryRole from "../archeryGameBundle/archeryRole";
import dartArrow from "./dartArrow";
import dartLosePage from "./dartLosePage";
import dartRole from "./dartRole";
import dartWinPage from "./dartWinPage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class dartGame extends cc.Component {

    @property({type:cc.Node,tooltip:"镖师节点"})
    armedNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"匪徒节点"})
    banditNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"弓箭节点"})
    archeryNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"箭节点"})
    arrowNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"角色父节点"})
    roleNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"背景节点"})
    bgNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"加箭按钮"})
    btnAdd:cc.Node = null;

    @property({type:cc.Label,tooltip:"箭的数量文本"})
    lb_count:cc.Label = null;
    
    @property({type:cc.Node,tooltip:"箱子"})
    box:cc.Node = null;

    /**保证金 */
    guarantee:number = 0;

    /** 酬金 */
    reward:number = 0;

    /** 镖师数量 */
    armedCount:number = 0;

    /** 匪徒数量 */
    banditCount:number = 0;

    shotInvert:number = 200;

    lastShotTime:number = 0;

    arrowCount:number = 10;

    killEnemyCount:number = 0;

    yPosAry:number[] = [-400,-300,-200,-100,0,100,200,300,400,500];

    meRoleAry:cc.Node[] = [];
    enemyRoleAry:cc.Node[] = [];

    async bindData(guarantee:number,reward:number,armedCount:number,banditCount:number){
        this.guarantee = guarantee;
        this.reward = reward;
        this.armedCount = armedCount;
        this.banditCount = banditCount; 
        this.arrowNode.getComponent(dartArrow).bindGame(this);
        physics_tool.openCollision();
        this.updateArrowCount();
        this.updateArrowBtn();
        await this.loadGame();
        this.bgAddEvent();
    }

    async loadGame(){
        let posAry:number[] = data_control.randomSortArray(this.yPosAry.concat());
        for(let i = 0;i<this.banditCount;i++){
            let node:cc.Node = cc.instantiate(this.banditNode);
            if(posAry.length <=0){
                posAry = data_control.randomSortArray(this.yPosAry.concat());
            }
            node.y = posAry.pop();
            this.roleNode.addChild(node);
            this.enemyRoleAry.push(node);
        }

        for(let i = 0;i<this.armedCount;i++){
            let node:cc.Node = cc.instantiate(this.armedNode);
            let box:cc.Node = cc.instantiate(this.box);
            if(posAry.length<=0){
                posAry = data_control.randomSortArray(this.yPosAry.concat());
            }
            let ny = posAry.pop();
            node.y = ny
            box.y = ny
            this.roleNode.addChild(node);
            this.roleNode.addChild(box);
            box.zIndex = -1;
            this.meRoleAry.push(node);
        }
    }

    bgAddEvent(){
        this.bgNode.on('touchend',this.onClickBg,this);
    }

    bgRemoveEvent(){
        this.bgNode.off('touchend',this.onClickBg,this);
    }

    onClickBg(){
        if(Date.now() - this.lastShotTime > 200){
            this.shotOneArrow();
            this.lastShotTime = Date.now();
        }
    }

    
    shotOneArrow(){
        if(this.arrowCount <= 0){
            O1HD.getModules().uiControlModule.showMessageBox("箭矢不足");
            return;
        }
        O1HD.getManagers().soundMgr.playSound("shot");
        let arrow:cc.Node = cc.instantiate(this.arrowNode);
        let as = arrow.getComponent(dartArrow);
        as.bindGame(this);
        this.node.addChild(arrow);
        as.startMove();
        this.arrowCount --;
        this.updateArrowCount();
        this.updateArrowBtn();
    }

    updateArrowCount(){
        this.lb_count.string = `×${this.arrowCount}`;
    }

    onBtnAddArrow(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.arrowCount += 5;
            this.updateArrowBtn();
            this.updateArrowCount();
        },()=>{},null,"拯救贵妃看广告增加箭矢");
    }

    updateArrowBtn(){
        if(this.arrowCount > 0){
            this.btnAdd.active = false;
        }else{
            this.btnAdd.active = true;
        }
    }

    
    coilderOneNode(tag:number,node:cc.Node){
        switch(tag){
            case archeryCoilderTag.enemy:{
                // 如果全部杀掉则胜利，否则失败
                this.killEnemyCount ++;
                let killCount:number = this.killEnemyCount;
                let ns = node.getComponent(dartRole);
                ns.death();
                if(killCount >= this.banditCount){
                    this.win();
                }
                break;
            }
            case archeryCoilderTag.friend:{
                // 失败
                let ns = node.getComponent(dartRole);
                ns.death();
                this.lose();
                break;
            }
        }
    }

    isGameOver:boolean = false;

    win(){
        if(this.isGameOver){
            return;
        }
        this.isGameOver = true;
        this.bgRemoveEvent();
        this.scheduleOnce(()=>{
            // 胜利
            if(this.checkHasArmeDeath()){
                this.showLose();
            }else{
                // 进入胜利结算
                let fun = (node:cc.Node)=>{
                    let ns = node.getComponent(dartWinPage);
                    ns.bindData(this.reward,this);
                }
                utilsView.openPopupLayerTwo(
                    FileKind.PrefabFilePath.dartWinPage,this.node,null,1,fun
                );
            }
        },2);
    }

    checkHasArmeDeath(){
        for(let i =0;i<this.meRoleAry.length;i++){
            let role:cc.Node = this.meRoleAry[i];
            let rs = role.getComponent(dartRole);
            if(rs.isDeath){
                return true;
            }
        }
        return false;
    }

    lose(){
        if(this.isGameOver){
            return;
        }
        this.isGameOver = true;
        this.bgRemoveEvent();

        this.scheduleOnce(()=>{ 
            this.showLose();
        },2);
    }

    showLose(){
        let fun = (node:cc.Node)=>{
            let ns = node.getComponent(dartLosePage);
            ns.bindGame(this);
        }
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.dartLosePage,this.node,null,1,fun
        );
    }

    closeThis(){
        this.node.destroy();
    }

    roleAlive(){
        for(let i =0;i<this.meRoleAry.length;i++){
            let role:cc.Node = this.meRoleAry[i];
            let rs = role.getComponent(dartRole);
            rs.alive();
        }
        this.isGameOver = false;
        this.bgAddEvent();
        if(this.killEnemyCount >= this.banditCount){
            this.win();
        }
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

}
